(function ($, Unison) {
  Drupal.behaviors.productFullV1 = {
    attach: function (context, settings) {
      if (settings?.global_variables?.cr24 == false) {
        return;
      }
      const bps = Unison?.fetch?.all();
      const bp = Unison?.fetch?.now().width;
      const STICKY_CLASS = 'product-full__footer__sticky';
      const $productFooter = $('.js-product-full__footer', context);
      const $productFooterAnchor = $('.js-product-full-footer-sticky-anchor', context);
      // *
      // * CR24: mobile only -- add to bag cta sticks and unsticks on scroll.
      // * Run the intersection observer only if landed on mobile / tablet
      // *
      if (bp !== bps?.landscape && $productFooter.length > 0 && $productFooterAnchor.length > 0) {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.boundingClientRect.bottom < 0) {
                $productFooter.addClass(STICKY_CLASS);
              } else {
                $productFooter.removeClass(STICKY_CLASS);
              }
            });
          },
          {
            threshold: [0]
          }
        );

        observer.observe($productFooterAnchor[0]);
      }
    }
  };
})(jQuery, Unison);
